import classNames from 'classnames';
import { CalloutLayoutTypesClassic, TemplateClassNames } from '../../../../types/template-layouts';
import { ModuleMap, PageModule, PageModuleType } from '../../../../types/working-model';
import { getEventNameURL, getStylingOverrides } from '../../utils';
import './call-out-layout.scss';
import { TypographyItem } from '../../../general-ui/typography-item/typography-item';
import { getTextValue } from '../../../../utils/utils';
import { useTypedSelector } from '../../../../store/reducers/use-typed-selector';
import { useParams } from 'react-router';
import { ParamsProps } from '../../live-event';
import LiveCallToAction from '../../../general-ui/live-call-to-action/live-call-to-action';
import React from 'react';

interface CallOutProps {
	module: PageModule;
	template: TemplateClassNames;
}

const CallOut = React.forwardRef<HTMLDivElement, CallOutProps>(({ module, template }, ref) => {
	const { eventBundle } = useTypedSelector(state => ({
		eventBundle: state.LiveEventReducer.eventBundle!
	}));
	// TODO: fix translations, language doesn't seem to be translation CTA button correctly
	const { eventName, language }: ParamsProps = useParams();

	const { content, styling_overrides } = module;
	const layout_type = content?.layout_type || CalloutLayoutTypesClassic.standard;
	const image = content?.image;
	const callOutImg = image ? { backgroundImage: `url(${image})` } : {};
	const callOutButtonText = content?.callToAction?.button_name[language];
	const pageLink = content?.callToAction?.content?.page || null;
	const sectionLink = content?.callToAction?.content?.section || null;
	const urlLink = content?.callToAction?.content?.url || null;
	const registration_on = eventBundle?.registration_on;
	const {
		backgroundColor,
		backgroundImg,
		descriptionOverrides,
		titleOverrides,
		primaryButtonOverrides,
	} = getStylingOverrides(styling_overrides);

	const { description, title } = getTextValue(content, language);

	return module.is_on && content && (
		<section
			id={ModuleMap[PageModuleType.callout]}
			className={classNames(
				'call-out',
				`call-out-${layout_type}`,
				template,
				backgroundColor
			)}
			ref={ref}
		>
			<div
				className="module-container"
				style={backgroundImg}
			>
				<div className="call-out-inner">
					<TypographyItem className={classNames('evt-caption-1 upper-call-out-title', descriptionOverrides)}>
						{description}
					</TypographyItem>
					<TypographyItem className={classNames('evt-heading-2 call-out-title', titleOverrides)} tagName="h2">
						{title}
					</TypographyItem>
					<LiveCallToAction
						classname={classNames(
							'primary',
							primaryButtonOverrides
						)}
						template={template}
						buttonText={callOutButtonText}
						pageLink={pageLink}
						sectionLink={sectionLink}
						urlLink={urlLink}
						eventName={eventName || getEventNameURL(eventBundle!)}
						uuid={eventBundle?.uuid}
						selectedLanguage={'en'}
						registration_on={registration_on}
					/>
				</div>
				<div className="call-out-image" style={callOutImg}></div>
			</div >
		</section >
	);
});

CallOut.displayName = 'CallOut';

export default CallOut;
